
<template>
    <div>
        <nav class="navbar">

            <div class="container">
                <div class="navbar-header">
                    <button type="button" class="navbar-toggle" data-toggle="collapse" data-target="#myNavbar">
                        <span class="icon-bar"></span>
                        <span class="icon-bar"></span>
                        <span class="icon-bar"></span>
                    </button>
                </div>
                <div class="collapse navbar-collapse" id="myNavbar">
                    <ul class="nav navbar-nav">
                        <router-link to="/" tag="li"><a>Startsidan</a></router-link>
                                               

                        <!--<router-link to="/robotarlist" tag="li"><a>Robotar</a></router-link>-->
                        <!--<li id="drpdwn" class="dropdown">
        <a href="#" class="dropdown-toggle" data-toggle="dropdown">Rapporter <i class="fa fa-caret-down fa-lg"></i></a>
        <ul class="dropdown-menu">
            <router-link tag="li" to="/rptsysteminfoklass"><a>System(Infoklass)</a></router-link>
            <router-link tag="li" to="/rptplattforms"><a>Plattformar</a></router-link>
            <router-link tag="li" to="/rptplattformsystems"><a>Plattform/System</a></router-link>
            <router-link tag="li" to="/rptgdpr"><a>GDPR Intressent</a></router-link>
        </ul>
    </li>-->

                    </ul>
                </div>
            </div>
          

        </nav>
    </div>

</template>
<script>

    (function ($) {
        $(document).ready(function () {
            $("#drpdwn").mouseleave(function () {
                $("#drpdwn").removeClass("open");
                $("#drpdwn > .dropdown-toggle > i").toggleClass("fa-caret-down", true);
                $("#drpdwn > .dropdown-toggle > i").toggleClass("fa-caret-up", false);
            });
            $("#drpdwn").mouseenter(function () {
                $("#drpdwn").addClass("open");
                $("#drpdwn > .dropdown-toggle > i").toggleClass("fa-caret-up", true);
                $("#drpdwn > .dropdown-toggle > i").toggleClass("fa-caret-down", false);
            });
        });
    })(jQuery);

    import EventBus from './event-bus.js';
    

    export default {
        data() {
            return {
                alla_indikatorer: [],              
                allaAvtal: null,
                warn: false,
            }
        },
        created: function () {
           
        },
        mounted: function () {           
           
        },
        methods: {
          
        }
    }

</script>



<style scoped>

    nav {
        background-color: #a79883;
        font-size: 1.2rem;
    }

        .navbar {
            border-radius: 0;
            margin-bottom: 0;
            border: 0px;
            width: 100%;
        }

        nav li a {
            border-right: none;
            box-shadow: none;
            text-decoration: none;
            transition: background-color 0.3s;
        }

    .navbar-nav > li > a:focus,
    .navbar-nav > li > a:hover,
    .navbar-nav > li > a:active,
    .nav .open > a,
    .navbar-nav > li:hover {
        font-weight: inherit;
        background-color: rgb(255, 136, 51);
        color: black;
    }

        .navbar-toggle .icon-bar {
            background-color: white;
        }

        .navbar-collapse {
            padding-left: 10px;
        }

        .dropdown-menu {
            border: none;
            padding: 0;
            font-size: 1.2rem;
        }

            .dropdown-menu > li > a {
                padding: 10px 0 10px 10px;
                background-color: white;
            }

                .dropdown-menu > li > a:hover {
                    background-color: #8FA8C8; /*#5b758c;*/
                    color: black;
                }

        .visningsinfo {
            padding-top: 0.7em;
            /* height: 2.2em;*/
            height: auto;
            background-color: rgba(143,168,200,1);
            color: black;
            text-align: center;
            width: 100%;
            font-size: 1.2em;
            padding-bottom: 0.6em;
            border-bottom: 1px solid rgba(0,0,0,0.2)
        }

        .visningsinfo_varning {
            padding-top: 0.7em;
            height: auto;
            background-color: #fff0f0;
            color: crimson;
            text-align: center;
            width: 100%;
            font-size: 1.2em;
            padding-bottom: 0.6em;
            border-bottom: 1px solid rgba(0,0,0,0.2);
        }

        .bi-alarm:before {
            position: relative;
            top: -15px;
        }

        .bi-alarm:before {
            font-size: 28px;
            position: relative;
            top: 4px;
            -webkit-animation: shake 0.1s ease-in-out 0.1s infinite alternate;
        }

        .shake {
            -webkit-animation: shake 0.07s ease-in-out 0.1s infinite alternate;
        }

        @-webkit-keyframes shake {
            from {
                -webkit-transform: rotate(5deg);
            }

            to {
                -webkit-transform-origin: center center;
                -webkit-transform: rotate(-5deg);
            }
        }

</style>



// WEBPACK FOOTER //
// src/SystemMenu.vue